import { Routing as NeoRouting } from '@singularsystems/neo-core';
import { Routing } from '@singularsystems/neo-react';
import { injectable } from 'inversify';
import { AppService, Types } from '../Services/AppService';

import NotFound from '../Components/404NotFound';
import OidcLoginRedirect from '../Views/Security/OidcLoginRedirect';
import { AppConfig } from '../AppConfig'

import * as InterceptionRoutes from '../../DataInterception/Routes/InterceptionRoutes';
import * as UserManagementRoutes from '../Routes/UserManagementRoutes';
import * as MaintenanceRoutes from '../../Maintenance/Routes/MaintenanceRoutes';
import { NeoReportingPureRoutes, NeoReportingRoutes } from '../../NeoReporting/NeoReportingModule';
import HomeView from '../../Home/Views/HomeView';
import HoldingsView from '../../Reports/Holdings/Views/HoldingsView';
import TransactionsView from '../../Reports/Transactions/Views/TransactionsView';
import { SecurityConfigRoute } from '../../Security/SecurityRoutes';
import { Holdings, Home, Transactions } from '../../AccessControl/Models/Commands/Security/Roles';
import ProvisionalTaxReportsVM from '../../Reports/ProvisionalTaxReports/Views/ProvisionalTaxReportsVM';
import ProvisionalTaxReportsView from '../../Reports/ProvisionalTaxReports/Views/ProvisionalTaxReportsView';

interface ICommonAppRouteProps {
    /** TODO: Add any custom route props here, like userType. */
}

export interface IAppRoute extends NeoRouting.IRoute, ICommonAppRouteProps {

}

export interface IAppMenuItem extends NeoRouting.IMenuRoute, ICommonAppRouteProps {

}

@injectable()
export class RouteService {

    private routeProvider: Routing.RouteProvider;

    constructor(private config = AppService.get(Types.Config)) {

        this.routeProvider = new Routing.RouteProvider(
            this.getMenuRoutes(),
            this.getPureRoutes(),
            NotFound,
        )
    }

    public get routes(): Routing.RouteProvider {
        return this.routeProvider;
    }

    // TODO: Add routes for each menu item
    private getMenuRoutes(): NeoRouting.IMenuRoute[] {
       // InterceptionRoutes.InterceptionRoutes.children?.push();
       // MaintenanceRoutes.MaintenanceRoutes.children?.push();
        if(this.config.isDevelopment){
            UserManagementRoutes.UserManagementRoutes.children?.push(SecurityConfigRoute);
        }
        return [
            {
                name: "Home",
                path: '/', 
                component: HomeView,
                icon: "home",
                allowAnonymous: false,
                role: Home.Access
            },
            MaintenanceRoutes.MaintenanceRoutes,
            InterceptionRoutes.InterceptionRoutes,
            {
                name: "Data Extracts",
                expanded: false,
                icon: "file-alt",
                exact: true,
                allowAnonymous:false,
                role: Holdings.Access,
                children: [
                    {
                        name: "Holdings",
                        path: "/reports/holdings",
                        icon: "hand-holding-usd",
                        component: HoldingsView,
                        allowAnonymous: false,
                        role: Holdings.Access
                    },
                    {
                        name: "Transactions",
                        path: "/reports/transactions",
                        icon: "hand-holding-usd",
                        component: TransactionsView,
                        allowAnonymous: false,
                        role: Transactions.Access
                    },
                    {
                        name: "Provisional Tax Reports",
                        path: "/reports/ProvisionalTaxReports",
                        icon: "hand-holding-usd",
                        component: ProvisionalTaxReportsView,
                        allowAnonymous: false,
                        role: Transactions.Access
                    },
                ]
            },
            UserManagementRoutes.UserManagementRoutes,
            NeoReportingRoutes,
        ]
    }

    private getPureRoutes(): NeoRouting.IRoute[] {
        const pureRoutes = [
            {
                path: AppConfig.loginRedirectRoute, component: OidcLoginRedirect, allowAnonymous: true
            },
            ...InterceptionRoutes.PureRoutes,
            ...MaintenanceRoutes.PureRoutes,
            ...UserManagementRoutes.PureRoutes,
            ...NeoReportingPureRoutes,
        ];
        if(!this.config.isDevelopment){
            pureRoutes.push(SecurityConfigRoute);
        }
        return pureRoutes;
    }
}